<template>
  <div class="filter-area" :class="{ 'is-expanded': expanded }">
    <el-form :inline="false" :label-width="'104px'" class="filter-form">
      <div class="filter-grid" :class="gridClass">
        <!-- 筛选字段 -->
        <el-form-item
          v-for="(field, index) in visibleFields"
          :key="field.id"
          :label="field.label"
          class="filter-field"
        >
          <component :is="field.component" v-bind="field.props">
            <template v-if="field.component === 'el-select' && field.options">
              <el-option
                v-for="option in field.options"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </template>
          </component>
        </el-form-item>
        
        <!-- 操作按钮组（最后一行） -->
        <div v-if="isLastRow" class="filter-actions">
          <el-button
            v-if="hasMoreFields"
            type="text"
            :icon="expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            @click="toggleExpand"
          >
            {{ expanded ? '收起' : '展开' }}
          </el-button>
          <el-button
            v-if="showSettings"
            class="icon-button icon-button--settings"
            icon="el-icon-setting"
            @click="handleSettings"
          />
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'FilterArea',
  props: {
    fields: {
      type: Array,
      required: true
    },
    defaultExpanded: {
      type: Boolean,
      default: false
    },
    showSettings: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: this.defaultExpanded,
      columns: 3
    }
  },
  computed: {
    // 响应式列数计算
    gridClass() {
      return `grid-cols-${this.columns}`
    },
    // 默认显示两行
    defaultVisibleCount() {
      return this.columns * 2
    },
    visibleFields() {
      return this.expanded
        ? this.fields
        : this.fields.slice(0, this.defaultVisibleCount)
    },
    hasMoreFields() {
      return this.fields.length > this.defaultVisibleCount
    },
    isLastRow() {
      // 判断当前是否在最后一行
      const visibleCount = this.visibleFields.length
      const lastRowStart = Math.floor((visibleCount - 1) / this.columns) * this.columns
      return visibleCount > lastRowStart
    }
  },
  mounted() {
    this.updateColumns()
    window.addEventListener('resize', this.updateColumns)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateColumns)
  },
  methods: {
    updateColumns() {
      if (typeof window === 'undefined') return
      const width = window.innerWidth
      this.columns = width >= 1600 ? 4 : width >= 1280 ? 3 : 3
    },
    toggleExpand() {
      this.expanded = !this.expanded
    },
    handleReset() {
      this.$emit('reset')
    },
    handleSearch() {
      this.$emit('search')
    },
    handleSettings() {
      this.$emit('settings')
    }
  }
}
</script>

